var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.4 22.4c-.2 0-.3-.1-.4-.2-.2-.2-.2-.6 0-.8l8.6-8.6L9 4.5c-.2-.2-.2-.6 0-.8s.6-.2.8 0l9.1 8.7c.1.1.2.3.2.4 0 .2-.1.3-.2.4l-9.1 9.1c-.1 0-.2.1-.4.1"
})));
export default SvgArrowRight;